import { Pipe, PipeTransform } from '@angular/core';

interface Hideable {
  hide?: boolean;
}

@Pipe({
  name: 'filterHidden',
})
export class FilterHiddenPipe implements PipeTransform {

   transform<T extends Hideable> (array: T[]): T[] {
    return array.filter((elem)=> {
      return elem?.hide !== true
    });
  }

}
